import { Link } from "react-router-dom";
import ButtonOne from "../../../components/buttons/buttonOne";

export default function IntroProduct() {
    return (
        <div className="flex flex-col w-full h-full items-center justify-center gap-y-[2rem] py-[2rem]">
            <h2 id="design-robotics" className="font-bold text-[35px] lg:text-[45px] w-[67%]">
                Design Robots with Us
            </h2>
            <div className="flex flex-col xl:flex-row justify-center items-center w-[80%] xl:w-[70%] h-full">
                <img
                    src="/images/product/firstkit_PCB.webp"
                    alt="PCB and components for an engineering kit used in education robotics"
                    className="xl:w-[50%] max-w-l h-auto"
                />
                <div className="flex flex-col gap-y-[1rem] w-[80%] xl:w-[50%] xl:ml-[3rem]">
                    <p>We are dedicated to sharing our knowledge on how to design robots from the ground up.</p>
                    <p>
                        Practical learning for <strong>students robotics</strong> and <strong>robotics for classrooms</strong>.
                    </p>
                    <Link to="https://shop.takamorirobot.com" target="_blank" aria-label="Learn more about our beginner robotics course and engineering kit">
                        <ButtonOne 
                            position=""
                        >
                            {/* Subscribe */}
                            Buy a Robotics Dev Kit
                        </ButtonOne>
                    </Link>
                </div>
            </div>
        </div>
    )
}